import type { NavigationPinnedView } from '../../types/module';

const TYPE_LABELS: Record<'all' | 'stock' | 'raw' | 'fg' | 'service' | 'consumable' | 'fixed_asset', string> = {
    all: 'All Items',
    stock: 'Stock Only',
    raw: 'Raw Materials',
    fg: 'Finished Goods',
    service: 'Services Only',
    consumable: 'Consumables Only',
    fixed_asset: 'Fixed Assets Only',
};

export type InventoryTab = 'status' | 'ledger';
export type InventoryFilterType = 'all' | 'stock' | 'raw' | 'fg' | 'service' | 'consumable' | 'fixed_asset';

export function buildInventoryPinnedView(tab: InventoryTab, type: InventoryFilterType): NavigationPinnedView {
    if (tab === 'ledger') {
        return {
            id: `inventory:${tab}:all`,
            path: '/inventory?tab=ledger&type=all',
            label: 'Inventory - Stock Ledger',
            scope: 'inventory',
            created_at: new Date().toISOString(),
        };
    }

    return {
        id: `inventory:${tab}:${type}`,
        path: `/inventory?tab=status&type=${type}`,
        label: `Inventory - Current Status - ${TYPE_LABELS[type]}`,
        scope: 'inventory',
        created_at: new Date().toISOString(),
    };
}
